import { allTrackers } from "app/services/track/track";

import { createLeadsSearchTrackingService } from "./factory";

const leadsSearchTrackingService = createLeadsSearchTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));

export default leadsSearchTrackingService;
